import {Component, OnInit} from "@angular/core";
import {MachineManagerService} from "../../../services/machine-manager.service";
import {SessionManagerService} from "../../../services/session-manager.service";

@Component({
  selector: "admin-dashboard-machine",
  templateUrl: "./machine.component.html",
  styleUrls: ["./machine.component.css"]
})
export class MachineComponent implements OnInit {

  constructor(
    private machineManager: MachineManagerService,
    private sessionManager: SessionManagerService
  ) {
  }
  ngOnInit(): void {
    this.reload();
  }

  reload() {
    let owner = this.sessionManager?.session?.space ?? ""
    this.machineManager.load(owner)
  }

  getMachine() {
    return this.machineManager.machine;
  }

}
